module.exports = __webpack_public_path__ + "media/images/application/contact/bienvenue-0eb92a09465cb92bbd283111d7d5d44e.svg";